import * as React from "react";
import VerticalTable from "../../VerticalTable";
import hscTeamMembers from "../../../hsc-team-members";
import DocTitle from 'react-document-title';

const loanStructureHeadings = [
    {
        name:'Select All/Deselect All',
        key:'is_printable',
        format: 'checkbox',
        tooltip: 'Check if you want the quote to be printed'
    },
    {
        name: 'Loan Structure',
        key: 'loan_structure',
    }];
   const nonRefiHeader=[{
        name: 'Purchase Price',
        key: 'purchase_price',
        format: 'integer',
        isDollar: true
    },
    {
        name: 'Down Payment (%)',
        key: 'down_payment_percent',
        format: 'percent'
    },
    {
        name: 'Down Payment ($)',
        key: 'down_payment',
        format: 'integer',
        isDollar: true,
        tooltip: 'Purchase Price * Down Payment (%)'
    }];
    const refiHeader=[{
        name: 'Estimated Appraised Value',
        key: 'purchase_price',
        format: 'integer',
        isDollar: true
    },
    {
        name: 'Equity Amount (%)',
        key: 'down_payment_percent',
        format: 'percent'
    },
    {
        name: 'Equity Amount ($)',
        key: 'down_payment',
        format: 'integer',
        isDollar: true,
        tooltip: 'Purchase Price * Down Payment (%)'
    }];
   
    const loanHeadings = [{
        name: 'Loan Amount',
        key: 'loan_amount',
        format: 'integer',
        isDollar: true,
        tooltip: 'Purchase Price - Down Payment ($)'
    }, 
    {
        name: 'Interest Rate',
        key: 'interest_rate',
        format: 'percent',
        decimals: 2
    }, 
    {
        name: 'Loan Term',
        key: 'loan_term',
        format: 'years'
    }, 
    {
        name: 'Maturity',
        key: 'maturity',
        format: 'years'
    }, 
    {
        name: 'Amortization',
        key: 'amortization',
        format: 'dropdown',
        dropdownType: 'loanquotes-amortization'
    },
    {
        name: 'Prepayment Penalty',
        key: 'prepayment_penalty',
    }, 
    {
        name: 'Recourse',
        key: 'recourse',
        format: 'dropdown',
        dropdownType: 'confirmType',
    }, 
    {
        name: 'NOI',
        key: 'noi',
        format: 'integer',
        isDollar: true
    }, 
    {
        name: 'Loan Payment - Annual',
        key: 'loan_payment_annually',
        format: 'integer',
        isDollar: true,
        tooltip: '-PMT(Interest Rate / 12, Amortization * 11.8, Loan Amount) * 12)'
    }, 
    {
        name: 'Cash Flow - Annual',
        key: 'cash_flow_annually',
        format: 'integer',
        isDollar: true,
        tooltip:'NOI - Annual Loan Payment'
    }, 
    {
        name: 'Cash Flow - Monthly',
        key: 'cash_flow_monthly',
        format: 'integer',
        isDollar: true,
        tooltip:'Annual Cash Flow / 12'
    }, 
    {
        name: 'Cash on Cash',
        key: 'cash_on_cash',
        format: 'percent',
        tooltip: 'Annual Cash Flow / Down Payment ($)',
        isPrintable:false
    }, 
    {
        name: 'Total Origination Fee',
        key: 'total_origination_fee',
        format: 'percent',
        isDollar: false
    },
    {
        name: 'Notes',
        key: 'notes',
        format: 'textarea'
    },  
    {
        name: 'NOI Percentage',
        key: 'noi_percentage',
        format: 'integer',
        isDollar: false,
        isPrintable:false
    },
    {
        name: 'NOI * NOI Percentage',
        key: 'noi_multiplied',
        format: 'integer',
        isDollar: true,
        tooltip: 'NOI * NOI (%)',
        isPrintable:false
    },
    {
        name: 'DSCR',
        key: 'dscr',
        format: 'float',
        tooltip:'NOI / Annual Loan Payment',
        isPrintable:false
    }, 
    {
        name:'Debt Yield',
        key: 'debt_yield',
        format:'percent',
        tooltip:'NOI / Loan Amount',
        isPrintable:false
    },
    {
        name: 'Bank',
        key: 'bank',
        isPrintable:false
    },
    {
        name: 'Bank Contact',
        key: 'bank_contact',
        isPrintable:false
    }];

    const LoanQuotes = ({printTitle, data, NOIPercent,LoanType, handleChangeInput, handleChangeDropdown, handleNOIPercentChange, viewMode, hscTeamMemberIds, handlePrintPagesDropDown, addNewColumn, updateColumns}) => {
    const hscMemberId = Array.isArray(hscTeamMemberIds) ? hscTeamMemberIds[0] : hscTeamMemberIds && hscTeamMemberIds.EMAIL ;
    const hscTeamMemberDetail = hscTeamMembers.filter(details => hscMemberId == details.EMAIL);
    let headings = LoanType === "Refi" || LoanType === "Construction" ? [...loanStructureHeadings, ...refiHeader,...loanHeadings] : [...loanStructureHeadings, ...nonRefiHeader,...loanHeadings];
    return (
        <div className="LoanQuotes">
            <DocTitle title={printTitle}/>
            <VerticalTable
                printTitle = {printTitle}
                headings={headings}
                columns={data}
                isEditable={!viewMode} 
                handleChangeInput={handleChangeInput}
                handleChangeDropdown={handleChangeDropdown}
                handlePrintPagesDropDown={handlePrintPagesDropDown}
                hasPrint={true}
                hscTeamMemberDetail = {hscTeamMemberDetail}
                addNewColumn={addNewColumn}
                updateColumns={updateColumns} 
            />
        </div>
    );
};

export default LoanQuotes;